import { useEffect, useMemo, useState } from 'react';
import axiosConn from '../axiosConn';
import { getLocalOpsAccessPlayer } from '../utils/localOpsOpsAccess';

const normalizeCurrentPlayerResponse = (response) => {
  const candidate =
    response?.data?.data?.data ||
    response?.data?.data?.player ||
    response?.data?.data ||
    response?.data?.player ||
    response?.data ||
    null;
  return candidate && !Array.isArray(candidate) ? candidate : null;
};

export default function useLocalOpsAccessPlayer(authPlayer) {
  const token = authPlayer?.token || '';
  const [freshPlayer, setFreshPlayer] = useState(null);
  const [status, setStatus] = useState(token ? 'idle' : 'disabled');

  useEffect(() => {
    if (!token) {
      setFreshPlayer(null);
      setStatus('disabled');
      return undefined;
    }

    let active = true;
    setStatus('loading');
    setFreshPlayer(null);

    axiosConn
      .get('players/me', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (!active) return;
        const nextPlayer = normalizeCurrentPlayerResponse(response);
        setFreshPlayer(nextPlayer || null);
        setStatus(nextPlayer ? 'success' : 'empty');
      })
      .catch(() => {
        if (!active) return;
        setFreshPlayer(null);
        setStatus('error');
      });

    return () => {
      active = false;
    };
  }, [token]);

  const accessPlayer = useMemo(
    () => getLocalOpsAccessPlayer(authPlayer, freshPlayer),
    [authPlayer, freshPlayer],
  );

  return {
    accessPlayer,
    freshPlayer,
    status,
    loading: status === 'loading' || status === 'idle',
  };
}

export { normalizeCurrentPlayerResponse };
